"use strict";

exports.__esModule = true;
exports.default = subquery;
/**
 * Helper function to get only parts of a query. Specify
 * which parameters to include.
 */
function subquery(query) {
  if (!query) {
    return query;
  }

  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return params.reduce(function (newQuery, param) {
    newQuery[param] = query[param];
    return newQuery;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/react-url-query/lib/utils/subquery.js
// module id = 153
// module chunks = 131683993344931 142807904292071 231608221292675